import React, { useState } from 'react';
import { Text, View } from "../../../Components/Themed";
import { useColors } from "../../../constants/useColors";
import type { MyPlayerProps, OrderProps, PostCommentProps, PublicPlayerProps, TextTagProps } from "../../../types";
import { FormattedText } from '../../FormattedTextInput/FormattedText';
import moment from 'moment-mini';
import { Image } from 'react-native';
import ImageRenderer from '../../ImageRenderer';
import UrlPreviewCard from '../../UrlPreviewCard';
import SocialOrdersList from '../../SocialOrdersList';

type PostCommentCardProps = {
    post_comment:PostCommentProps,
    me?:MyPlayerProps,
    orders:OrderProps[],
    player?:PublicPlayerProps,
    mine?:boolean,
    onCopyOrder?:(order:OrderProps) => void,
    onFadeOrder?:(order:OrderProps) => void,
    onSelectImage:(image:{ url:string, height?:number, width?:number }) => void,
    onSelectTag:(tag:TextTagProps) => void
}
const MAX_IMAGE_WIDTH = 400
const PostCommentCard = ({post_comment, orders, player, onSelectImage, onSelectTag, onCopyOrder, onFadeOrder}:PostCommentCardProps) => {
    const [ comment_size, setCommentSize ] = useState({ width:0 })
    const Colors = useColors();
    const image = post_comment.comment_images ? post_comment.comment_images[0] : undefined
    const url = post_comment.comment_urls ? post_comment.comment_urls[0] : undefined
    const image_width = comment_size.width > 400 ? MAX_IMAGE_WIDTH : comment_size.width
    return (
        <View transparent style={{ flexDirection:'row', alignItems:'flex-start', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
            <View float style={{ borderRadius:100, padding:2 }}>
                <Image
                    source={{ uri:player?.profile_pic }}
                    style={{ height:36, width:36, borderRadius:100 }}
                    resizeMode='cover'
                />
            </View>
            <View style={{ flex:1, marginLeft:10 }} onLayout={(ev) => {
                const { width } = ev.nativeEvent.layout
                setCommentSize({ width })
            }}>
                <View type='row'>
                    <Text theme='h2' style={{ flex:1, marginRight:10 }}>@{player?.username ?? 'Anonymous'}</Text>
                    <Text theme='light' style={{ marginTop:3 }}>Delivered {moment(post_comment.create_datetime).format('hh:mm a')}</Text>
                </View>
                <View type='body' style={{ marginTop:5 }}>
                    <View transparent nativeID='comment'>
                        {post_comment.formatted_text ?
                        <FormattedText
                            text={post_comment.formatted_text}
                            tags={post_comment.tags ?? []}
                            text_color={Colors.text.h1}
                            onSelectTag={(tag) => onSelectTag(tag)}
                        />
                        : post_comment.message ?
                        <Text size={12} theme='h2'>{post_comment.message}</Text>
                        :<></>}
                    </View>
                {image ?
                <View transparent style={{ justifyContent:'center', alignItems:'center', marginTop:10 }}>
                    <ImageRenderer
                        image={image}
                        width={image_width}
                        max_height={300}
                        onSelectImage={onSelectImage}
                    />
                </View>
                :<></>}
                {url ?
                <View transparent style={{ justifyContent:'center', alignItems:'center', marginTop:10 }}>
                 <UrlPreviewCard
                    url={url}
                    max_height={120}
                    width={comment_size.width}
                    color={Colors.text.white}
                />
                </View>
                :<></>}
                {player && orders && orders.length > 0 ?
                <View float style={{ padding:4, marginTop:10 }}>
                    <SocialOrdersList
                        orders={orders}
                        onCopyOrder={onCopyOrder}
                        onFadeOrder={onFadeOrder}
                        maxWidth={comment_size.width}
                        players={[player]}
                        direction='horizontal'
                        

                    />
                </View>
                :<></>}
            </View>
            </View>
            
        </View>
    )
}

export default PostCommentCard